import { Collection, Plugin } from 'ckeditor5';
export class PlaceholderStore extends Plugin {
    static get pluginName() {
        return 'PlaceholderStore';
    }
    init() {
        this.placeholderData = new Collection();
        this.registerPlaceholders();
    }
    registerPlaceholders() {
        const { conversion } = this.editor;
        // Fires for all placeholder elements — both on initial editing view rebuild after upcast
        // and when a new placeholder is inserted. The instanceId is set on the model element by
        // OrcaPlaceholderSchema (upcast) or by the toolbar (new insertion).
        conversion.for('downcast').add((dispatcher) => {
            dispatcher.on('insert:placeholder', (_, data) => {
                var _a;
                const { item } = data;
                const placeholderId = item.getAttribute('id');
                const instanceId = item.getAttribute('instanceId');
                if (placeholderId === undefined || !instanceId)
                    return;
                const value = ((_a = item.getChildren().next().value) === null || _a === void 0 ? void 0 : _a.data) || placeholderId;
                this.addPlaceholderToStore(instanceId, placeholderId, value, true);
            });
        });
        this.editor.model.document.on('change', () => {
            const root = this.editor.model.document.getRoot();
            if (!root)
                return;
            const presentInstanceIds = new Set();
            for (const item of this.editor.model.createRangeIn(root).getItems()) {
                if (item.is('element', 'placeholder')) {
                    const instanceId = item.getAttribute('instanceId');
                    if (instanceId) {
                        presentInstanceIds.add(instanceId);
                    }
                }
            }
            for (const placeholder of this.placeholderData) {
                if (!presentInstanceIds.has(placeholder.id)) {
                    this.setInDocument(placeholder.id, false);
                }
            }
        });
    }
    removedPlaceholders() {
        return this.placeholderData.filter((placeholder) => !placeholder.inDocument);
    }
    setInDocument(id, inDocument) {
        const item = this.placeholderData.get(id);
        if (item) {
            item.inDocument = inDocument;
        }
    }
    addPlaceholderToStore(instanceId, placeholderId, value, inDocument) {
        const existing = this.placeholderData.get(instanceId);
        if (existing) {
            existing.inDocument = inDocument;
            return;
        }
        this.placeholderData.add({ id: instanceId, placeholderId, value, inDocument });
    }
    updatePlaceholderId(instanceId, newPlaceholderId) {
        const item = this.placeholderData.get(instanceId);
        if (item) {
            item.placeholderId = newPlaceholderId;
        }
    }
    getPlaceholderFromStore(placeholderId) {
        return this.placeholderData.find((p) => p.placeholderId === placeholderId) || null;
    }
    getAllPlaceholdersFromStore() {
        return [...new Set(this.placeholderData.map(({ placeholderId }) => placeholderId))];
    }
    /**
     * Distinct, non-empty refs currently in the document.
     *
     * Unlike `getAllPlaceholdersFromStore` this ignores tombstoned entries and unconfigured
     * placeholders, which is what a question list wants to know about.
     */
    getRefsInDocument() {
        const refs = this.placeholderData
            .filter(({ inDocument, placeholderId }) => inDocument && Boolean(placeholderId))
            .map(({ placeholderId }) => placeholderId);
        return [...new Set(refs)];
    }
    /** How many times this question is referenced by a placeholder in the document. */
    countOccurrences(ref) {
        return this.placeholderData.filter(({ inDocument, placeholderId }) => inDocument && placeholderId === ref).length;
    }
}
